const spawn = require('child_process').spawn
const util = require('../lib/util')
const log = require('./log')

util.loadConfig()
    .then((config) => {
      log.green(config)
    })
    .catch((error) => {
      log.red(error)
    })

// TODO: Interactive template
const params = process.argv.slice(2)

spawn('git', ['commit'].concat(params), { stdio: 'inherit' })
